import { Observable } from 'rxjs';
import { GameApplicationsService } from '@games/infra';
import { inject } from '@angular/core';
import { RemoveApplicationCommandPayload } from './remove-application.command-payload';
import { UserParticipationStatus } from '@core-http';

export class RemoveApplicationCommandHandler {
  private readonly gameApplicationsService: GameApplicationsService = inject(GameApplicationsService);

  remove(payload: RemoveApplicationCommandPayload): Observable<void> {
    const isApproved: boolean = payload.participationStatus === UserParticipationStatus.Approved;

    if (isApproved) {
      return this.gameApplicationsService.removeFromGame({ gameId: payload.gameId }, payload.leaveReason);
    }

    return this.gameApplicationsService.removeApplication({ gameId: payload.gameId });
  }
}
